import React from 'react'
import { useTranslation } from 'react-i18next'

const QUICK_EMOJIS = ['❤️', '😂', '😮', '🔥', '👏']

// Compact reaction strip beneath a capture. Quick-emoji bar on the
// left (tap to toggle), aggregated reactions on the right showing
// emoji + count, with mine highlighted. Mirrors the messages-module
// reaction UX so the affordance reads the same across both pages.
export default function MomentsReactions({ captureId, viewerId, reactions = [], onReact }) {
  const { t } = useTranslation()

  // Aggregate by emoji.
  const agg = reactions.reduce((acc, r) => {
    if (!acc[r.emoji]) acc[r.emoji] = { count: 0, mine: false }
    acc[r.emoji].count += 1
    if (r.user_id === viewerId) acc[r.emoji].mine = true
    return acc
  }, {})
  const aggEntries = Object.entries(agg)

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5">
      {QUICK_EMOJIS.map((emoji) => (
        <button
          key={emoji}
          type="button"
          onClick={() => onReact?.(captureId, emoji)}
          className="grid h-7 w-7 place-items-center rounded-full bg-neutral-100 text-base hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700"
          aria-label={t('moments.reactWith', { emoji })}
        >
          {emoji}
        </button>
      ))}
      {aggEntries.length > 0 && (
        <div className="ms-auto flex flex-wrap items-center gap-1">
          {aggEntries.map(([emoji, { count, mine }]) => (
            <button
              key={emoji}
              type="button"
              onClick={() => onReact?.(captureId, emoji)}
              className={`flex items-center gap-1 rounded-full px-2 py-0.5 text-xs ${
                mine
                  ? 'bg-rose-500/10 text-rose-500 ring-1 ring-rose-500/30'
                  : 'bg-neutral-100 dark:bg-neutral-800'
              }`}
            >
              <span>{emoji}</span>
              <span dir="auto">{count}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
